import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnMount: false,
      },
      // https://tanstack.com/query/latest/docs/framework/react/examples/nextjs-app-prefetching?path=examples/react/nextjs-app-prefetching/app/get-query-client.ts&panel=code
      dehydrate: {
        // include pending queries in dehydration
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
        // Next.js redacts errors itself and needs the originals to detect dynamic pages
        shouldRedactErrors: () => false,
      },
    },
  });
